<template>
  <div id="paper">
    <div class="container">
      <el-form
        :model="loginForm"
        :rules="rules"
        class="login-container animated bounceInDown"
        label-position="left"
        label-width="0px"
        v-loading="loading"
      >
        <h5 class="text-center text-warning mb-3">用户注册</h5>
        <el-form-item prop="username">
          <el-input
            type="text"
            v-model="loginForm.username"
            auto-complete="off"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            auto-complete="off"
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            type="text"
            v-model="loginForm.nickname"
            auto-complete="off"
            placeholder="昵称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            type="text"
            v-model="loginForm.phoneNumber"
            auto-complete="off"
            placeholder="电话号码"
          ></el-input>
        </el-form-item>
        <el-form-item class="text-center">
          <el-button type="warning" class="btn-block" v-on:click="register"
            >立即注册</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      rules: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      },
      loginForm: {
        username: "",
        password: "",
        nickname: ""
      },
      loading: false
    };
  },
  methods: {
    register() {
      this.axios
        .post("/login/register", {
          username: this.loginForm.username,
          password: this.loginForm.password,
          nickname: this.loginForm.nickname,
          phoneNumber: this.loginForm.phoneNumber
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "注册成功！请等待管理员审核",
              type: "success"
            });
            this.$router.replace("/login").catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "注册失败！"
            });
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
#paper {
  background: url("../assets/img/bg/bg.jpg");
  height: 100%;
  width: 100%;
  position: fixed;
}

.login-container {
  background-color: rgba(248, 248, 255, 0.2);
  border-radius: 5px;
  margin: 90px auto;
  max-width: 400px;
  padding: 30px;
}
</style>
